import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";

type HeaderProps = {
  className?: string;
} & ComponentProps<"header">;

export const Header = ({ className, ...props }: HeaderProps) => (
  <header
    className={cn(
      "tw:flex tw:items-center tw:justify-between tw:rounded-t-lg tw:border tw:border-b-0! tw:border-solid tw:border-fill-quinary tw:px-3 tw:py-2.5 tw:sm:py-4.25",
      className,
    )}
    {...props}
  />
);
